import { motion, useReducedMotion } from 'framer-motion';

import pt from '../../locales/pt';
import { LANDING_EASE } from './ScrollReveal';

const TONE = {
  sage: 'bg-sage-500',
  want: 'bg-[#C7986C]',
  save: 'bg-[#6B8FA8]',
};

/**
 * Feature visual — ds/card/budget-by-group pattern on Landing.
 */
export function BudgetMiniApp() {
  const data = pt.landing.features.miniBudget;
  const reduceMotion = useReducedMotion();

  return (
    <div className="w-full max-w-[340px] rounded-ds-xl border border-border bg-card p-space-6">
      <p className="font-display text-type-title-card font-semibold text-foreground">{data.title}</p>
      <p className="type-body-sm mt-space-1 text-muted-foreground">{data.period}</p>
      <ul className="mt-space-4 flex flex-col gap-space-3">
        {data.rows.map((row) => (
          <li key={row.label}>
            <div className="mb-space-1 flex items-center justify-between gap-space-2">
              <span className="type-body-sm font-medium text-foreground">{row.label}</span>
              <span className="type-body-sm tnum text-muted-foreground">{row.amount}</span>
            </div>
            <div className="h-2 overflow-hidden rounded-ds-full bg-stone-100 dark:bg-stone-700">
              <motion.div
                className={`h-full rounded-ds-full ${TONE[row.tone] || TONE.sage}`}
                initial={reduceMotion ? false : { width: 0 }}
                whileInView={{ width: `${row.trackPct}%` }}
                viewport={{ once: true, amount: 0.5 }}
                transition={{ duration: 0.7, delay: 0.2, ease: LANDING_EASE }}
              />
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
